var map = {
	"./new-cta-link-active.svg": 771,
	"./new-cta-link-disabled.svg": 772,
	"./new-cta-link.svg": 773,
	"./new-image-active.svg": 774,
	"./new-image-disabled.svg": 775,
	"./new-image.svg": 776,
	"./new-shape-active.svg": 777,
	"./new-shape-disabled.svg": 778,
	"./new-shape.svg": 779,
	"./new-stories-active.svg": 780,
	"./new-stories-disabled.svg": 781,
	"./new-stories.svg": 782,
	"./new-text-active.svg": 783,
	"./new-text-disabled.svg": 784,
	"./new-text.svg": 785,
	"./new-upload-active.svg": 786,
	"./new-upload-disabled.svg": 787,
	"./new-upload.svg": 788,
	"./template-active.svg": 789,
	"./template-disabled.svg": 790,
	"./template.svg": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 770;